import { ApiModel } from "./api-model";
import { Value } from "./value";
import * as moment from "moment";
import { Moment } from "moment";
import {
  ProgramArticleTranslation,
  ProgramArticleTranslationETT,
  Destination,
} from "./program-article-translation";

export class ProgramArticle extends ApiModel {
  id: number;
  updateDate: Moment;
  broadcasting: Value;
  category: Value;
  channel: Value;

  startDate: Date;
  endDate: Date;
  length: string;
  lastUpdate: Moment;

  // Used for MagicBox Schedule creation from the program
  broadcastDate: Date;

  // Sport Classification
  sport: Value;
  competition: Value;
  event: Value;
  age: Value;
  discipline: Value;
  round: Value;
  gender: Value;

  // Non Sport Classification
  type: Value;
  label: Value;
  group: Value;

  // On list, need a single value for sport or Type
  elementList: string;

  // Chapca Metadata
  newLevels: Value[];

  // Chapca Non Sportive Ids
  contentId: string;

  commentator: string;

  // TEMP INFO
  infosupp: string;
  playersPSG: string;

  magicBoxScheduleAvailable: boolean;

  spev: Value;
  variant: Value;
  spevJ0: Value;
  variantJ0: Value;
  translations: ProgramArticleTranslation[];
  destinations: Destination[];
  translationsETT: ProgramArticleTranslationETT[];
  active: boolean;
  pictureModified: boolean;
  programId: number;
  transmissionId: string;
  btSportProductCode: string;
  classificationId: number;
  idFirstBroadcast: Value;
  isSport: boolean;

  availableLanguages: number[];
  // MultiCam
  isMultiCam: boolean;
  isMain: boolean;

  isBT: boolean;
  isRescue: boolean;
  rescueAction: string;
  isHidden: boolean;

  tieringName: string;
  tieringNameJ0: string;
  multiCamRelations: MultiCamRelation[];

  // ProgramExternalId
  valEmiId: number;
  cocoonId: number;
  // Language
  language: Value;

  title: string;
  broadcastId: string;

  getTitle(destination: Value) {
    this.title = this.elementList;
    if (destination) {
      if (this.destinations.find((t) => t.id == destination.value)) {
        let translation = this.destinations
          .find((t) => t.id == destination.value)
          .value.translations.find((t) => t.name == "Title");
        if (translation && translation.content) {
          this.title = translation.content;
        }
      }
    }
    return this.title;
  }

  getCommentatorShort() {
    if (!this.commentator) {
      return "";
    }

    let commentators = this.commentator.split("|");

    if (commentators.length === 0) {
      return "";
    } else if (commentators.length > 2) {
      return commentators[0] + "|" + commentators[1] + "...";
    } else {
      return this.commentator;
    }
  }

  hasBeenUpdatedRecently() {
    return this.getHoursDiff() < 24;
  }

  getHoursDiff() {
    var currentTime = moment();
    var timeStore = moment(this.updateDate);
    return currentTime.diff(timeStore, "h");
  }

  HasLastUpdate() {
    return this.updateDate.toString() !== "0001-01-01T00:00:00";
  }

  GetUpdateDateCleaned() {
    return moment(this.updateDate).format("DD/MM/YYYY HH:mm:ss");
  }

  getMultiCamType() {
    return this.isMain ? "Main" : "Sub";
  }

  isSpevInMultiCamRelations(spevId: number) {
    var result = false;
    if (this.isMultiCam) {
      if (this.multiCamRelations.find((mci) => mci.mainSpevId === spevId)) {
        result = true;
      } else {
        this.multiCamRelations.forEach((multiCamInfo) => {
          if (multiCamInfo.subSpevIds.find((ssi) => ssi === spevId)) {
            result = true;
          }
        });
      }
    }
    return result;
  }

  isCurrent() {
    var currentTime = moment();
    return currentTime.isBetween(moment(this.startDate), moment(this.endDate));
  }

  constructor(data: any) {
    data.startDate = moment(data.startDate).toDate();
    data.endDate = moment(data.endDate).toDate();
    data.broadcastDate = moment(data.broadcastDate).toDate();
    data.lastUpdate = moment(data.lastUpdate);

    super(data);

    const valueKeys = [
      "broadcasting",
      "category",
      "channel",
      "city",
      "competition",
      "country",
      "leg",
      "match",
      "sport",
      "type",
      "event",
    ];
    valueKeys.forEach((key) => {
      if (this[key]) {
        this[key] = new Value(this[key]);
      } else {
        this[key] = new Value({ id: null, value: null });
      }
    });

    this.active = false;
    this.pictureModified = false;
    this.elementList = this.sport.value
      ? this.sport.value
      : this.type.value
      ? this.type.value
      : "";
  }

  getTranslationsByType(type: string) {
    return this.translations.find((translation) => translation.id === type);
  }

  /**
   * Remove picture raw data to avoid heavy request
   */
  cleanPicture(blob: boolean) {
    if (this.translations && this.translations.length > 0) {
      this.translations = this.translations.map((t) => {
        if (t.value["picture"]) {
          const formats = [
            "original",
            "format_16_9",
            "format_4_3",
            "format_3_4",
          ];
          formats.forEach((format) => {
            if (t.value.picture[format]) {
              t.value.picture[format].displayUrl = null;
              if (blob && t.value.picture[format].blob) {
                t.value.picture[format].blob = null;
              }
            }
          });
        }
        return t;
      });
    }
  }

  assignNewPictures(translations) {
    translations.forEach((translation) => {
      this.translations
        .filter((t) => t.id === translation.id)
        .map((t) => {
          if (t.value.picture && t.value.picture.duplicatedFromLanguage) {
            const formats = [
              "original",
              "format_16_9",
              "format_4_3",
              "format_3_4",
            ];
            formats.forEach((format) => {
              if (t.value.picture[format]) {
                t.value.picture[format] = translation.value.picture[format];
              }
            });
          }
        });
    });
  }
}

export class MultiCamRelation extends ApiModel {
  mainSpevId: number;
  subSpevIds: number[];
}



// WEBPACK FOOTER //
// ./src/app/models/program-article.ts